import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FleetLTRoutingModule } from './fleet-lt-routing.module';
import { SideNavService } from 'src/app/shared/layouts/side-nav/services/side-nav.service';
import FleetLongTermSidenavConfig from './fleetLongTermSidenavConfig';

/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * NOTE THAT THIS MODULE WILL BE LOADED IN THE APP.
 * DO NOT IMPORT ANYTHING IN HERE.
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 */

@NgModule({
  declarations: [],
  imports: [CommonModule, FleetLTRoutingModule],
  exports: [],
  providers: [],
})
export class FleetLTModule {
  /**
   * CODE IN HERE WILL BE EXECUTED ON APP LOAD.
   * USE IT TO INJECT YOUR SUB APP INTO THE MAIN APPLICATION
   */

  constructor(private sideNavService: SideNavService) {
    this.sideNavService.addSubMenuItems(
      'flt',
      FleetLongTermSidenavConfig.fleetLongTermLinks
    );
    this.sideNavService.addSubMenuItems(
      'setting',
      FleetLongTermSidenavConfig.settingsFleetLongTermLinks
    );
  }
}
